module.exports = __webpack_public_path__ + "ec4a29d8181617769d6c3f02c80f1b44.png";